import * as types from "../../actions/types";



const initialState = {
  main: [],
  studentTabData: {},      // { main: {...}, family: [...], ... }
  deletionsTracker: {},    // { family: [id1], benefits: [id2], ... }
  specialistTerms: [],
  studentFiles: [],
}


export default function students(state = initialState, action) {
  switch (action.type) {

    case types.SET_STUDENTS_DATA_MAIN:
      return {
        ...state,
        main: action.payload
      }
    case types.SET_STUDENTS_DATA_FAMILY:
      return {
        ...state,
        family: action.payload
      }
    case types.SET_STUDENTS_BASE_INFO:
      return {
        ...state,
        studentBaseInfo: action.payload
      };
    case types.SET_STUDENTS_DATA_OTHER:
      return {
        ...state,
        [action.table || action.entity]: action.payload
      }

    case types.GET_STUDENT_TAB_DATA:
      return {
        ...state,
        studentTabData: {
          ...state.studentTabData,
          [action.payload.tab]: action.payload.data
        }
      };

    case types.ADD_STUDENT_DELETION:
      const { apiTab, itemId } = action.payload;
      return {
        ...state,
        deletionsTracker: {
          ...state.deletionsTracker,
          [apiTab]: [...(state.deletionsTracker[apiTab] || []), itemId]
        }
      };

    case types.CLEAR_STUDENT_DELETIONS:
      return {
        ...state,
        deletionsTracker: {}
      };

    case types.GET_STUDENT_SPECIALIST_TERMS:
      return {
        ...state,
        specialistTerms: action.payload
      };

    case types.GET_STUDENT_FILES:
      return {
        ...state,
        studentFiles: action.payload
      };

    default:
      return state;
  }
}